/* eslint-disable no-new-func */
/**
 * /* eslint-disable no-new-func
 *
 * @format
 */


const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";

export default isBrowser;
